import type { z } from 'zod';

import { NonEmptyText } from './non-empty-text';

// TODO: Add validation for HealthcareUserId
export const HealthcareUserId = NonEmptyText;

export type HealthcareUserId = z.infer<typeof HealthcareUserId>;
